module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'analysis' && templateVars.config ?
				templateVars.config :
				{
	"config": {
		"colors": [
			"#2b4559",
			"#005a9c",
			"#3c7ab4",
			"#deb65e",
			"#ebd3a1",
			"#b2b2b2",
			"#dadada",
			"#ff9896",
			"#9467bd",
			"#c5b0d5",
			"#8c564b",
			"#c49c94",
			"#e377c2",
			"#f7b6d2",
			"#7f7f7f",
			"#c7c7c7",
			"#bcbd22",
			"#dbdb8d",
			"#17becf"
		],
		"selectionMaximum": 7,
		"size": {
			"height": 350,
			"width": 530
		},
		"disableHash": false
	},
	"data": {
		"presets": [],
		"years": [
			2012,
			2013,
			2014,
			2015,
			2016
		],
		"units": {
			"млн долл. США": {
				"ru": "млн долл. США",
				"en": "US $ million"
			},
			"%": {
				"ru": "%",
				"en": "%"
			},
			"-": {
				"ru": "",
				"en": ""
			},
			"долл. США": {
				"ru": "долл. США",
				"en": "US $"
			},
			"тонны": {
				"ru": "тонны",
				"en": "Tons"
			},
			"тыс.тр. унций": {
				"ru": "тыс.тр. унций",
				"en": "Thousand troy ounces"
			},
			"чел.": {
				"ru": "чел.",
				"en": "people"
			},
			"тыс. чел.": {
				"ru": "тыс. чел.",
				"en": "Thousand people"
			},
			"тыс. тонн": {
				"ru": "тыс. тонн",
				"en": "тыс. тонн"
			},
			"млн т": {
				"ru": "млн т",
				"en": "Million tons"
			},
			"млн  м3": {
				"ru": "млн  м3",
				"en": "Million m3"
			}
		},
		"groups": [
			{
				"id": 1,
				"title": {
					"ru": "Ключевые финансовые показатели",
					"en": "Key financial indicators"
				},
				"items": [
					{
						"id": 1,
						"title": {
							"ru": "Выручка",
							"en": "Revenue"
						},
						"units": "млн долл. США",
						"values": [
							12366,
							11499,
							11869,
							8542,
							8259
						]
					},
					{
						"id": 2,
						"title": {
							"ru": "EBITDA",
							"en": "EBITDA"
						},
						"units": "млн долл. США",
						"values": [
							4932,
							4198,
							5681,
							4296,
							3899
						]
					},
					{
						"id": 3,
						"title": {
							"ru": "Рентабельность EBITDA",
							"en": "EBITDA margin"
						},
						"units": "%",
						"values": [
							39.9,
							36.5,
							47.9,
							50.3,
							47.2
						]
					},
					{
						"id": 4,
						"title": {
							"ru": "Чистая прибыль",
							"en": "Net profit"
						},
						"units": "млн долл. США",
						"values": [
							2143,
							765,
							2000,
							1716,
							2531
						]
					},
					{
						"id": 5,
						"title": {
							"ru": "Капитальные затраты",
							"en": "Сapital expenditures"
						},
						"units": "млн долл. США",
						"values": [
							2713,
							1989,
							1298,
							1654,
							1695
						]
					},
					{
						"id": 6,
						"title": {
							"ru": "Свободный денежный поток",
							"en": "Free cash flow"
						},
						"units": "млн долл. США",
						"values": [
							520,
							2606,
							4725,
							2405,
							1591
						]
					},
					{
						"id": 7,
						"title": {
							"ru": "Чистый долг",
							"en": "Net debt"
						},
						"units": "млн долл. США",
						"values": [
							3986,
							4584,
							3537,
							4212,
							4551
						]
					},
					{
						"id": 8,
						"title": {
							"ru": "Чистый долг / EBITDA",
							"en": "Net debt / EBITDA"
						},
						"units": "-",
						"values": [
							0.8,
							1.1,
							0.6,
							1,
							1.2
						],
						"axis_y_precision_format": ".1f"
					},
					{
						"id": 9,
						"title": {
							"ru": "Дивиденд на акцию",
							"en": "Dividend per share"
						},
						"units": "долл. США",
						"values": [
							12.7,
							18.9,
							20.7,
							18.1,
							7.8
						]
					}
				]
			},
			{
				"id": 2,
				"title": {
					"ru": "Отчет о прибылях и убытках",
					"en": "Profits and Losses Report"
				},
				"items": [
					{
						"id": 10,
						"title": {
							"ru": "Выручка",
							"en": "Revenue"
						},
						"units": "млн долл. США",
						"values": [
							12366,
							11499,
							11869,
							8542,
							8259
						]
					},
					{
						"id": 11,
						"title": {
							"ru": "Валовая прибыль",
							"en": "Gross profit"
						},
						"units": "млн долл. США",
						"values": [
							5999,
							4993,
							6195,
							4761,
							4100
						]
					},
					{
						"id": 12,
						"title": {
							"ru": "Прибыль от операционной деятельности",
							"en": "Operating profit"
						},
						"units": "млн долл. США",
						"values": [
							3864,
							2476,
							4746,
							3506,
							3281
						]
					},
					{
						"id": 13,
						"title": {
							"ru": "EBITDA",
							"en": "EBITDA"
						},
						"units": "млн долл. США",
						"values": [
							4932,
							4198,
							5681,
							4296,
							3899
						]
					},
					{
						"id": 14,
						"title": {
							"ru": "Рентабельность EBITDA",
							"en": "EBITDA margin"
						},
						"units": "%",
						"values": [
							39.9,
							36.5,
							47.9,
							50.3,
							47.2
						]
					},
					{
						"id": 15,
						"title": {
							"ru": "Прибыль до налогов",
							"en": "Profit before taxes"
						},
						"units": "млн долл. США",
						"values": [
							3143,
							1330,
							2660,
							2244,
							3276
						]
					},
					{
						"id": 16,
						"title": {
							"ru": "Чистая прибыль",
							"en": "Net profit"
						},
						"units": "млн долл. США",
						"values": [
							2143,
							765,
							2000,
							1716,
							2531
						]
					},
					{
						"id": 17,
						"title": {
							"ru": "Прибыль без учета неденежных списаний",
							"en": "Profit without taking into account non-cash write-offs"
						},
						"units": "млн долл. США",
						"values": [
							3039,
							2537,
							3968,
							3167,
							2264
						]
					}
				]
			},
			{
				"id": 3,
				"title": {
					"ru": "Отчет о финансовом положении",
					"en": "Statement of financial position"
				},
				"items": [
					{
						"id": 18,
						"title": {
							"ru": "Совокупные Активы",
							"en": "Total assets"
						},
						"units": "млн долл. США",
						"values": [
							20974,
							18781,
							13149,
							13371,
							16457
						]
					},
					{
						"id": 19,
						"title": {
							"ru": "Акционерный капитал",
							"en": "Total equity"
						},
						"units": "млн долл. США",
						"values": [
							12940,
							9750,
							4793,
							2261,
							3896
						]
					},
					{
						"id": 20,
						"title": {
							"ru": "Совокупные обязательства",
							"en": "Total liabilities"
						},
						"units": "млн долл. США",
						"values": [
							8034,
							9031,
							8356,
							11110,
							12561
						]
					},
					{
						"id": 21,
						"title": {
							"ru": "Совокупный долг",
							"en": "Gross debt"
						},
						"units": "млн долл. США",
						"values": [
							5023,
							6205,
							6330,
							8266,
							7852
						]
					},
					{
						"id": 22,
						"title": {
							"ru": "Чистый долг",
							"en": "Net debt"
						},
						"units": "млн долл. США",
						"values": [
							3986,
							4584,
							3537,
							4212,
							4551
						]
					},
					{
						"id": 23,
						"title": {
							"ru": "Оборотный капитал",
							"en": "Working capital"
						},
						"units": "млн долл. США",
						"values": [
							4044,
							3018,
							1087,
							1030,
							443
						]
					}
				]
			},
			{
				"id": 4,
				"title": {
					"ru": "Отчет о движении денежных средств",
					"en": "Statement of cash flows"
				},
				"items": [
					{
						"id": 24,
						"title": {
							"ru": "Денежные средства от операционной деятельности, нетто",
							"en": "Net cash generated from operating activities"
						},
						"units": "млн долл. США",
						"values": [
							3434,
							4344,
							5947,
							3705,
							3492
						]
					},
					{
						"id": 25,
						"title": {
							"ru": "Денежные средства, направленные на инвестиционную деятельность, нетто",
							"en": "Net cash used in investing activities"
						},
						"units": "млн долл. США",
						"values": [
							-2914,
							-1738,
							-1222,
							-1300,
							-1901
						]
					},
					{
						"id": 26,
						"title": {
							"ru": "Денежные средства, направленные на финансовую деятельность, нетто",
							"en": "Net cash used in financing activities"
						},
						"units": "млн долл. США",
						"values": [
							-1164,
							-1975,
							-2979,
							-998,
							-2399
						]
					},
					{
						"id": 27,
						"title": {
							"ru": "Свободный денежный поток",
							"en": "Free cash flow"
						},
						"units": "млн долл. США",
						"values": [
							520,
							2606,
							4725,
							2405,
							1591
						]
					},
					{
						"id": 28,
						"title": {
							"ru": "Изменение оборотного капитала",
							"en": "Change in working capital"
						},
						"units": "млн долл. США",
						"values": [
							329,
							-1026,
							-1935,
							-57,
							-587
						]
					},
					{
						"id": 29,
						"title": {
							"ru": "Дивиденды выплаченные Компанией",
							"en": "Dividends paid by the Company"
						},
						"units": "млн долл. США",
						"values": [
							-960,
							-2989,
							-3281,
							-2859,
							-1232
						]
					},
					{
						"id": 30,
						"title": {
							"ru": "Капитальные затраты",
							"en": "Сapital expenditures"
						},
						"units": "млн долл. США",
						"values": [
							2713,
							1989,
							1298,
							1654,
							1695
						]
					}
				]
			},
			{
				"id": 5,
				"title": {
					"ru": "Дивиденды",
					"en": "Dividends"
				},
				"items": [
					{
						"id": 31,
						"title": {
							"ru": "Дивиденды объявленные за период",
							"en": "Dividends attributed for the year"
						},
						"units": "млн долл. США",
						"values": [
							2008,
							2200,
							4798,
							2148,
							1100
						]
					},
					{
						"id": 32,
						"title": {
							"ru": "Дивиденды выплаченные Компанией",
							"en": "Dividends paid by the Company"
						},
						"units": "млн долл. США",
						"values": [
							960,
							2989,
							3281,
							2859,
							1232
						]
					},
					{
						"id": 33,
						"title": {
							"ru": "Дивиденд на акцию",
							"en": "Dividend per share"
						},
						"units": "долл. США",
						"values": [
							12.7,
							18.9,
							20.7,
							18.1,
							7.8
						]
					},
					{
						"id": 34,
						"title": {
							"ru": "Прибыль на акцию",
							"en": "Margin per share"
						},
						"units": "долл. США",
						"values": [
							13.7,
							4.9,
							12.7,
							11,
							16.1
						]
					}
				]
			},
			{
				"id": 6,
				"title": {
					"ru": "Производственные показатели",
					"en": "Performance indicators"
				},
				"items": [
					{
						"id": 35,
						"title": {
							"ru": "Никель",
							"en": "Nickel"
						},
						"units": "тонны",
						"values": [
							300340,
							285292,
							274248,
							266406,
							235749
						]
					},
					{
						"id": 36,
						"title": {
							"ru": "Медь",
							"en": "Copper"
						},
						"units": "тонны",
						"values": [
							363764,
							371063,
							368009,
							369426,
							360217
						]
					},
					{
						"id": 37,
						"title": {
							"ru": "Палладий",
							"en": "Palladium"
						},
						"units": "тыс.тр. унций",
						"values": [
							2732,
							2661,
							2752,
							2689,
							2618
						]
					},
					{
						"id": 38,
						"title": {
							"ru": "Платина",
							"en": "Platinum"
						},
						"units": "тыс.тр. унций",
						"values": [
							683,
							651,
							662,
							656,
							644
						]
					}
				]
			},
			{
				"id": 7,
				"title": {
					"ru": "Доли на рынке металлов",
					"en": "Shares in the Metal Market"
				},
				"items": [
					{
						"id": 39,
						"title": {
							"ru": "Никель",
							"en": "Nickel"
						},
						"units": "%",
						"values": [
							17,
							14,
							13,
							14,
							12
						]
					},
					{
						"id": 40,
						"title": {
							"ru": "Медь",
							"en": "Copper"
						},
						"units": "%",
						"values": [
							2,
							2,
							2,
							2,
							2
						]
					},
					{
						"id": 41,
						"title": {
							"ru": "Палладий",
							"en": "Palladium"
						},
						"units": "%",
						"values": [
							41,
							41,
							44,
							39,
							40
						]
					},
					{
						"id": 42,
						"title": {
							"ru": "Платина",
							"en": "Platinum"
						},
						"units": "%",
						"values": [
							11,
							11,
							14,
							11,
							11
						]
					}
				]
			},
			{
				"id": 8,
				"title": {
					"ru": "Показатели устойчивого развития",
					"en": "Indicators of sustainable development"
				},
				"items": [
					{
						"id": 43,
						"title": {
							"ru": "Среднесписочная численность сотрудников",
							"en": "Average number of employees"
						},
						"units": "чел.",
						"values": [
							81973,
							83005,
							79897,
							81637,
							81081
						]
					},
					{
						"id": 44,
						"title": {
							"ru": "Средняя зарплата работников Группы в России",
							"en": "Average salary of the Group's employees in Russia"
						},
						"units": "долл. США",
						"values": [
							2201,
							2365,
							1963,
							1392,
							1404
						]
					},
					{
						"id": 45,
						"title": {
							"ru": "Текучесть персонала",
							"en": "Staff turnover"
						},
						"units": "%",
						"values": [
							11.8,
							12.1,
							11.3,
							10.7,
							10.5
						]
					},
					{
						"id": 46,
						"title": {
							"ru": "Количество сотрудников, прошедших обучение",
							"en": "Number of employees trained"
						},
						"units": "тыс. чел.",
						"values": [
							48.7,
							47.9,
							54.1,
							63.1,
							70
						]
					},
					{
						"id": 47,
						"title": {
							"ru": "Коэффициент частоты травм с временной потерей трудоспособности (LTIFR)",
							"en": "LTIFR"
						},
						"units": "-",
						"values": [
							0.76,
							0.8,
							0.48,
							0.62,
							0.33
						]
					},
					{
						"id": 48,
						"title": {
							"ru": "Коэффициент частоты несчастных случаев со смертельным исходом (FIFR)",
							"en": "FIFR"
						},
						"units": "-",
						"values": [
							0.06,
							0.1,
							0.07,
							0.12,
							0.11
						]
					},
					{
						"id": 49,
						"title": {
							"ru": "Общее количество несчастных случаев",
							"en": "Total number of accidents"
						},
						"units": "чел.",
						"values": [
							103,
							106,
							64,
							88,
							53
						]
					},
					{
						"id": 50,
						"title": {
							"ru": "Текущие расходы на охрану окружающей среды",
							"en": "Costs of environmental protection"
						},
						"units": "млн долл. США",
						"values": [
							435,
							441,
							358,
							254,
							223
						]
					},
					{
						"id": 51,
						"title": {
							"ru": "Капитальные расходы на охрану окружающей среды",
							"en": "Capital expenditures for environmental protection"
						},
						"units": "млн долл. США",
						"values": [
							162,
							115,
							137,
							126,
							142
						]
					},
					{
						"id": 52,
						"title": {
							"ru": "Выбросы загрязняющих веществ в атмосферу",
							"en": "Emissions into the atmosphere"
						},
						"units": "тыс. тонн",
						"values": [
							2097.58,
							2097,
							2008,
							2064,
							1936
						]
					},
					{
						"id": 53,
						"title": {
							"ru": "Образование отходов на предприятиях",
							"en": "Waste generation in enterprises"
						},
						"units": "млн т",
						"values": [
							43.48,
							40.49,
							35.17,
							33.64,
							33.18
						]
					},
					{
						"id": 54,
						"title": {
							"ru": "Использование отходов на предприятиях",
							"en": "Use of waste in enterprises"
						},
						"units": "млн т",
						"values": [
							20.89,
							19.35,
							18.24,
							18.81,
							20.15
						]
					},
					{
						"id": 55,
						"title": {
							"ru": "Общий объем забираемой воды",
							"en": "Total amount of water taken"
						},
						"units": "млн  м3",
						"values": [
							377.21,
							399.83,
							399.18,
							398.29,
							381.87
						]
					},
					{
						"id": 56,
						"title": {
							"ru": "Вклад в реализацию программы переселения",
							"en": "Implementation of the resettlement program"
						},
						"units": "млн долл. США",
						"values": [
							26.7,
							26.1,
							21.6,
							13.6,
							12.4
						]
					}
				]
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/analysis/config.yaml
// module id = 131
// module chunks = 0